import importer from 'common/importer'
/* NAVIGATOR */
const { navigate, ROUTES } = importer('NavigationService', null)
/* ALERT */
const alert = importer('Helpers/Alert')
export default function * failure ({ error }) {
   // console.log(JSON.stringify(error))
  yield alert(
    'Login Error',
    'An error has occurred with Login[2]'
  )
  yield navigate(ROUTES.Dashboard)
}
